<template>
    <div v-show="visible">
        <el-dialog title="转移学校" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose" width="400px">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item  label="转移的人员：">
                    {{ form.currentName }}
                </el-form-item>
                <el-form-item label="当前学校名称：">
                    {{ form.currentDeptName }}
                </el-form-item>
                <el-form-item   prop="targetDeptId" label="目标学校名称：">
                    <el-select v-model="form.targetDeptId"  clearable placeholder="请选择">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                props: { multiple: true,  checkStrictly: true },
                depts:[],
                form:{
                    currentId: "",   // 转移人员ID
                    currentName:"", // 转移人员姓名
                    currentDeptId:"", // 转移学校ID
                    currentDeptName:"", // 转移学校名称
                    targetDeptId: "",
                },
                rules: {
                    targetDeptId: [ 
                        { required: true, message: '请选择学校', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
             init(selectData, deptId){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                // 每次进入初始值
                this.form.currentId = ""
                this.form.currentName = ""
                this.form.currentDeptId = ""
                this.form.currentDeptName = ""
                this.form.targetDeptId = ""

                let ids="",names="",deptNames=""
                for(let i =0;i<selectData.length;i++){
                    let data = selectData[i]
                    if(ids.length > 0){
                        ids+=","
                    }
                    ids+=data.id
                    
                    if(names.length > 0){
                        names+=","
                    }
                    names+=data.name

                    if(deptNames.length == 0){
                        deptNames=data.deptName
                    }
                    // console.log('选中的数据',data.id,data.name,data.deptName)
                }
                console.log('选中数据',ids, names, deptNames,deptId) 
                this.form.currentId = ids
                this.form.currentName = names
                this.form.currentDeptName = deptNames
                this.form.currentDeptId = deptId
                this.getSchool()
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //部门
            getSchool(){
                let url  = this.getDeptAllSchoolUrl;
                let data = {
                    currDeptId: this.form.currentDeptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => { 
                    if(valid){
                        let url= this.userMoveSchoolUrl;
                        let data = {
                            ids: this.form.currentId,
                            targetDeptId: this.form.targetDeptId
                        };
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message, 5,true);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/sys/user/MoveSchool.vue